import {Image, Text, View} from '@react-pdf/renderer';
import styles from '../styles';
import scoreBoard from '../../../assets/image/validation-score/scoreBoard.svg';
import circleIndicator from '../../../assets/image/validation-score/circleIndicator.svg';
import {getScoreDegree} from '../../../pages/lendtech/receiveCredit/step1-validation/status3/ValidationScoreBoard';

const ValidationScoreBoard = ({score}: {score: number}) => {
  const clampedScore = Math.max(300, Math.min(850, score));
  const rotationDegree = getScoreDegree(clampedScore);

  return (
    <View style={styles.gaugeBlock}>
      <View style={styles.gaugeInner}>
        <Image
          source={scoreBoard}
          style={styles.scoreBoard}
          // resizeMode="contain"
        />

        {/* overlay that fills the parent and centers its children */}
        <View style={styles.overlay}>
          <Image
            source={circleIndicator}
            style={[
              styles.circleIndicatorCentered,
              {transform: `rotate(${rotationDegree}deg)`},
            ]}
            // resizeMode="contain"
          />
        </View>

        <View style={styles.scoreTextContainer}>
          <Text style={styles.scoreText}>{score}</Text>
        </View>
      </View>
    </View>
  );
};

export default ValidationScoreBoard;
